import axios from "axios";
import { buildRequests } from "../util/buildRequest";
import { DOMAIN } from "../util/constants";
import { SetAuthHeader } from "../util/SetAuthHeader";
import { SetResponseInterceptor } from "../util/SetResponseInterceptor";

const API = `${DOMAIN}/api/v1/reporting`;

const instance = axios.create({ baseURL: API });
SetResponseInterceptor(instance);

const authInstance = axios.create({ baseURL: API });
authInstance.interceptors.request.use(SetAuthHeader);
SetResponseInterceptor(authInstance);

const requests = buildRequests(instance);
const authRequests = buildRequests(authInstance);

export {
  API as REPORTING_API,
  requests as reporting_api_requests,
  authRequests as reporting_auth_api_requests,
};
